import React from "react";
import {
  ConsentClinicalSigningMode,
  ConsentDocumentActiveStage,
  ConsentDocumentSignatory,
  ConsentDocumentDisplayStatus,
  ConsentDocumentStatus,
} from "@source/api/models/consentModels";
import {getConsentStatusPresentation} from "@source/api/models/consentHelpers";
import styles from "./consentShared.module.scss";

export interface ConsentStatusLabelProps {
  status: ConsentDocumentStatus;
  displayStatus?: ConsentDocumentDisplayStatus;
  activeStages?: ConsentDocumentActiveStage[];
  clinicalSigningMode?: ConsentClinicalSigningMode;
  familySigningMode?: ConsentClinicalSigningMode;
  signatories?: ConsentDocumentSignatory[];
  className?: string;
}

export const ConsentStatusLabel = ({
  status,
  displayStatus,
  activeStages,
  clinicalSigningMode,
  familySigningMode,
  signatories,
  className = "",
}: ConsentStatusLabelProps) => {
  const presentation = getConsentStatusPresentation(status, activeStages, clinicalSigningMode, displayStatus, familySigningMode);
  return (
    <span
      className={`${styles.status} ${styles[`status_${presentation.tone}`]} ${className}`}
      aria-label={`Document status: ${presentation.label}`}
    >
      {presentation.label}
    </span>
  );
};
